export const UPDATE_DOCUMENT_SUCCESS = 'UPDATE_DOCUMENT_SUCCESS';

export const updateDocumentSuccess = document => ({
    type: UPDATE_DOCUMENT_SUCCESS,
    payload: { document },
});
